export default {
  checkout: 'checkout',
  pre_qualification: 'pre_qualification',
  simple_checkout: 'simple_checkout',
}
